// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tadbulb: PokeData = {
  "id": 938,
  "name": "tadbulb",
  "height": 3,
  "weight": 4,
  "base_experience": 54,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "thunder-shock",
    "flail",
    "mud-slap",
    "zap-cannon",
    "spark",
    "charge",
    "weather-ball",
    "mud-shot",
    "sucker-punch",
    "discharge",
    "electric-terrain"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "mud-slap",
    "zap-cannon",
    "mud-shot",
    "electric-terrain",
    "thunderbolt",
    "volt-crash",
    "volt-switch",
    "electric-wrath",
    "thunder-fang",
    "thunder-punch",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 491,
    "item": null,
    "species": [
      {
        "name": "tadbulb",
        "order": 940,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bellibolt",
        "order": 941,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 938,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49.5,
    "speed": 45,
    "ability_power": 59
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
